import { useState } from "react"
import { Button, Divider, InputNumber, Modal } from "antd";
import { useUpdateProgramDisplayIdxByUpdateProgramAdminRequest } from "./model";
import { useQueryClient } from "@tanstack/react-query";
import { ReactComponent as Close } from "../../../../../assets/images/icon/close.svg"

interface IProps {
    programId: number;
    defaultDisplayIdx: number;
}

const UpdateProgramDisplayIdxModal = ({ programId, defaultDisplayIdx }: IProps) => {
    const [open, setOpen] = useState<boolean>(false);
    const [displayIdx, setDisplayIdx] = useState<number | null>(defaultDisplayIdx);
    const updateProgramDisplayIdxByUpdateProgramAdminRequest = useUpdateProgramDisplayIdxByUpdateProgramAdminRequest();
    const queryClient = useQueryClient();
    const onClickSave = () => {
        if (!displayIdx) return;
        updateProgramDisplayIdxByUpdateProgramAdminRequest.mutate({ id: programId, displayIdx: displayIdx },
            {
                onSuccess: () => {
                    setOpen(false);
                    queryClient.invalidateQueries({ queryKey: ['getProgramList'] });
                }
            }
        )
    }

    return <>
        <div style={{ color: 'var(--ant-color-link)', cursor: 'pointer' }} onClick={() => setOpen(true)}>
            {defaultDisplayIdx
                ? defaultDisplayIdx
                : ' -'}
        </div>
        <Modal open={open} onCancel={() => setOpen(false)} footer={false} closeIcon={false}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ fontWeight: 600, fontSize: '20px' }}>
                    노출순서
                </div>
                <Close width={24} height={24} stroke="#555555" style={{ cursor: 'pointer' }} onClick={() => setOpen(false)} />
            </div>
            <Divider style={{ margin: '12px 0' }} />
            <div style={{ fontWeight: 600, fontSize: '14px', marginBottom: '12px' }}>
                순서 입력(큰 숫자가 가장 앞에 노출됩니다.)
            </div>
            <InputNumber size='large' value={displayIdx} onChange={q => setDisplayIdx(q)} min={0} style={{ width: '90%', marginBottom: '17px' }} controls={false} />
            <div style={{ textAlign: 'center' }}>
                <Button size='large' loading={updateProgramDisplayIdxByUpdateProgramAdminRequest.isPending} onClick={() => setOpen(false)}>
                    닫기
                </Button>
                <Button size='large' type='primary' style={{ marginLeft: '8px' }} loading={updateProgramDisplayIdxByUpdateProgramAdminRequest.isPending} onClick={() => onClickSave()}>
                    저장
                </Button>
            </div>
        </Modal>
    </>
}

export default UpdateProgramDisplayIdxModal;